// extracted by mini-css-extract-plugin
module.exports = {"customInput":"input_customInput__3bkg6","errorBorder":"input_errorBorder__2Myoc","withoutBorders":"input_withoutBorders__2OQgw","withoutShadow":"input_withoutShadow__1Ub7_"};